import React, { Component } from 'react'
import { connect } from "react-redux";
import { verifyPassword } from "../../../actions/auth.js";
// import { bool } from 'prop-types'

// import Row from '../../../common/grid/Row'
import Col from '../../../common/grid/Col'
import Input from '../../../common/input/Input'
import Button from '../../../common/button/Button'

import MdLockOutline from 'react-icons/lib/md/lock-outline'

class Dialog extends Component {
  state = {
    errors: [],
    value: ""
  }

  handleChange = (value) => {
    this.setState({ value })
  }

  handleClick = () => {
    const { value } = this.state
    let errors = []
    if (!value) {
      errors.push({ message: "please fillout this field" });
    }

    this.props.verifyPassword(this.props.email, this.state.value);
    this.setState({ errors })
  }

  handleCancel = () => {
    const { confirm } = this.props
    confirm(false, false)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({ errors: this.state.errors.concat(nextProps.errors) });
    } else {
      this.props.confirm(false, true);
    }
  }

  render() {
    const { errors } = this.state;
    if (!this.props.email) {
      return <div>Loading...</div>
    }
    return (
      <Col _bottom-32 dialog>
        <Col _bottom-8>
          <span>Please confirm your password before changing anything</span>
          <Input
            ph="Password"
            type="password"
            onChange={this.handleChange}
          >
            <MdLockOutline size="18" />
          </Input>
          <div className="errors">
            {errors.map((error, key) => <div key={key}>{error.message}</div>)}
          </div>
        </Col>
        <div className="dialog-buttons">
          <Button className="btn-plain" onClick={this.handleClick}>
            CONFIRM
                    </Button>
          <Button className="btn-plain" onClick={this.handleCancel}>
            CANCEL
                    </Button>
        </div>
      </Col>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    email: state.auth.currentUser.email,
    verified: state.auth.currentUser.passwordVerified,
    errors: state.errors.errors
  }
}

export default connect(mapStateToProps, { verifyPassword })(Dialog)



// WEBPACK FOOTER //
// ./src/components/main/profile/Dialog.js